import React from "react";
import "./Pie.css"; // Ensure you have a corresponding CSS file for styling

const Pie = ({ setChartConfig, chartConfig }) => {
  const handlePieChange = (key, value) => {
    setChartConfig((prevConfig) => {
      const clone = { ...prevConfig };
      clone.plotOptions.pie = {
        ...clone.plotOptions.pie,
        [key]: value
      };

      return clone;
    });
  };

  const handlePaddingChange = (key, value) => {
    setChartConfig((prevConfig) => {
      const clone = { ...prevConfig };
      clone.grid = {
        ...clone.grid,

        [key]: value
      };
      return clone;
    });
  };

  return (
    <div className="pie-settings-container">
      <h3>Pie Settings</h3>

      {/* Pie Left Offset */}
      <div className="pie-settings-section">
        <label className="pie-settings-label">Pie Left Offset</label>
        <input
          type="number"
          min="-300"
          value={chartConfig?.plotOptions?.pie?.offsetX}
          onChange={(e) => handlePieChange("offsetX", Number(e.target.value))}
        />
      </div>

      {/* Pie Top Offset */}
      <div className="pie-settings-section">
        <label className="pie-settings-label">Pie Top Offset</label>
        <input
          type="number"
          min="-300"
          value={chartConfig?.plotOptions?.pie?.offsetY}
          onChange={(e) => handlePieChange("offsetY", Number(e.target.value))}
        />
      </div>

      {/* DataLabels Offset */}
      <div className="pie-settings-section">
        <label className="pie-settings-label">DataLabels Offset</label>
        <input
          type="number"
          min="-300"
          value={chartConfig?.pie?.dataLabels?.offset}
          onChange={(e) => handlePieChange("dataLabels", { offset: Number(e.target.value) })}
        />
      </div>

      {/* Padding Settings */}
      <div className="pie-settings-section">
        <h4>Padding</h4>

        {/* Top Padding */}
        <div className="pie-settings-subsection">
          <label className="pie-settings-label">Top</label>
          <input
            type="number"
            min="0"
            value={chartConfig?.pie?.grid?.padding?.top}
            onChange={(e) =>
              handlePaddingChange("padding", {
                top: Number(e.target.value)
              })
            }
          />
        </div>

        {/* Right Padding */}
        <div className="pie-settings-subsection">
          <label className="pie-settings-label">Right</label>
          <input
            type="number"
            min="0"
            value={chartConfig?.pie?.grid?.padding?.right}
            onChange={(e) =>
              handlePaddingChange("padding", {
                right: Number(e.target.value)
              })
            }
          />
        </div>

        {/* Bottom Padding */}
        <div className="pie-settings-subsection">
          <label className="pie-settings-label">Bottom</label>
          <input
            type="number"
            min="0"
            value={chartConfig?.pie?.grid?.padding?.bottom}
            onChange={(e) =>
              handlePaddingChange("padding", {
                bottom: Number(e.target.value)
              })
            }
          />
        </div>

        {/* Left Padding */}
        <div className="pie-settings-subsection">
          <label className="pie-settings-label">Left</label>
          <input
            type="number"
            min="0"
            value={chartConfig?.pie?.grid?.padding?.left}
            onChange={(e) =>
              handlePaddingChange("padding", {
                left: Number(e.target.value)
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Pie;
